const TAGS: Record<string, [string, string?]> = {
  "": ["<em>", "</em>"],
  _: ["<strong>", "</strong>"],
  "*": ["<strong>", "</strong>"],
  "~": ["<s>", "</s>"],
  "\n": ["<br />"],
  " ": ["<br />"],
  "-": ["<hr />"],
};

/** Anula la sangría de una cadena basada en las primeras líneas con sangría */
function outdent(str: string): string {
  return str.replace(RegExp("^" + (str.match(/^(\t| )+/) || "")[0], "gm"), "");
}

/** Codifica caracteres especiales en entidades HTML */
function encodeAttr(str: string): string {
  return (str + "")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/** Analiza Markdown en una cadena HTML */
export default function parse(
  md: string,
  prevLinks?: Record<string, string>
): string {
  const tokenizer =
    /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|(  \n\n*|\n{2,}|__|\*\*|[_*]|~~)/gm;

  const context: string[] = [];
  let out = "";
  const links = prevLinks || {};
  let last = 0;
  let chunk = "";
  let prev = "";
  let token: RegExpExecArray | null;
  let inner = "";
  let t: string = "";

  function tag(token: string): string {
    const desc = TAGS[token[1] || ""];
    const end = context[context.length - 1] === token;
    if (!desc) return token;
    if (!desc[1]) return desc[0];
    if (end) context.pop();
    else context.push(token);
    return desc[end ? 1 : 0]!;
  }

  function flush(): string {
    let str = "";
    while (context.length) str += tag(context[context.length - 1]);
    return str;
  }

  md = md
    .replace(/^\[(.+?)\]:\s*(.+)$/gm, (_s, name, url) => {
      links[name.toLowerCase()] = url;
      return "";
    })
    .replace(/^\n+|\n+$/g, "");

  while ((token = tokenizer.exec(md))) {
    prev = md.substring(last, token.index);
    last = tokenizer.lastIndex;
    chunk = token[0];

    if (prev.match(/[^\\](\\\\)*\\$/)) {
      // texto escapado, lo dejamos pasar
    }
    // Bloques de código:
    else if ((t = token[3] || token[4])) {
      chunk =
        '<pre class="code ' +
        (token[4] ? "poetry" : token[2]?.toLowerCase() || "") +
        '"><code' +
        (token[2] ? ` class="language-${token[2].toLowerCase()}"` : "") +
        ">" +
        outdent(encodeAttr(t).replace(/^\n+|\n+$/g, "")) +
        "</code></pre>";
    }
    // Citas y listas:
    else if ((t = token[6])) {
      if (t.match(/\./)) {
        token[5] = token[5].replace(/^\d+/gm, "");
      }
      inner = parse(outdent(token[5].replace(/^\s*[>*+.-]/gm, "")));
      if (t === ">") t = "blockquote";
      else {
        t = t.match(/\./) ? "ol" : "ul";
        inner = inner.replace(/^(.*)(\n|$)/gm, "<li>$1</li>");
      }
      chunk = `<${t}>${inner}</${t}>`;
    }
    // Imágenes:
    else if (token[8]) {
      chunk = `<img src="${encodeAttr(token[8])}" alt="${encodeAttr(
        token[7]
      )}">`;
    }
    // Enlaces:
    else if (token[10]) {
      out = out.replace(
        "<a>",
        `<a href="${encodeAttr(token[11] || links[prev.toLowerCase()])}">`
      );
      chunk = flush() + "</a>";
    } else if (token[9]) {
      chunk = "<a>";
    }
    // Encabezados:
    else if (token[12] || token[14]) {
      const level = token[14] ? token[14].length : token[13] > "=" ? 1 : 2;
      t = "h" + level;
      chunk = `<${t}>${parse(token[12] || token[15], links)}</${t}>`;
    }
    // Código en línea:
    else if (token[16]) {
      chunk = `<code>${encodeAttr(token[16])}</code>`;
    }
    // Formato en línea: *em*, **strong**, etc.
    else if (token[17] || token[1]) {
      chunk = tag(token[17] || "--");
    }

    out += prev;
    out += chunk;
  }

  return (out + md.substring(last) + flush()).replace(/^\n+|\n+$/g, "");
}
